import styled from "styled-components";

export const Value = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Symbol = styled.div`
  margin-right: 1px;
`;
